export class EntConfig {
  public ConfigKey: string;
  public LOB: string;
  public CREATED_D: string;
  public UPDATED_D: string;
  public CREATED_I: string;
  public UPDATED_I: string;
  public QueueConfig: Object;
  public MessageConfig = {
    lang: 'en-US',
    closures: {},
    messages: {}
  }
  public OverflowConfig: Object;
  constructor() {
    this.ConfigKey = '';
    this.LOB = '';
    this.CREATED_D = Math.floor(Date.now() / 1000).toString();
    this.UPDATED_D = Math.floor(Date.now() / 1000).toString();
    this.CREATED_I = '';
    this.UPDATED_I = '';
    this.QueueConfig = {
      voicemail: null,
      agentWhisper: '',
    },
    this.MessageConfig = {
      lang: 'en-US',
      closures: {},
      messages: {}
    },
    this.OverflowConfig = {
      overFlowBehavior: '',
      transferNumber: '',
      queueArn: ''
    }
  }
}
